import {CommonModule}                                              from '@angular/common';
import {booleanAttribute, Component, ElementRef, input, ViewChild} from '@angular/core';
import {ChartConfiguration}                                        from 'chart.js';
import {ChartCompBase}                                             from '../../tools/chart-comp.base';


@Component({
			   selector   : 'lib-chart-doughnut',
			   imports    : [CommonModule],
			   templateUrl: './chart-doughnut.component.html',
			   styleUrl   : './chart-doughnut.component.css'
		   })
export class ChartDoughnutComponent extends ChartCompBase<'doughnut', any> {
	@ViewChild('ChartItem') chartItem!: ElementRef<HTMLCanvasElement>;
	@ViewChild('LegendWrapper') legendWrapper!: ElementRef<HTMLDivElement>;
	chartConf = input.required<ChartConfiguration<'doughnut'>>();
	disableLegend = input(booleanAttribute(false), {transform: booleanAttribute});
}
